import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

/**
 * Picks the default landing page after login based on role.
 * Client → /portal (own documents). Everyone else → /dashboard.
 */
export function RoleLandingRedirect() {
  const { user } = useAuth();
  if (user?.role === "client") return <Navigate to="/portal" replace />;
  return <Navigate to="/dashboard" replace />;
}
